import { splitEmailAddressList } from './splitEmailAddressList';

/** True when the inbound message has CC (or multiple To) recipients for Reply All. */
export const canReplyAllToMessage = (message: {
  ccRecipients?: string | null;
  toRecipients?: string | null;
}): boolean => {
  if ((message.ccRecipients || '').trim()) {
    return true;
  }

  return splitEmailAddressList(message.toRecipients).length > 1;
};
